/* eslint-disable react-hooks/exhaustive-deps */
import { SxProps, Theme } from "@mui/material";
import { useEffect, useState } from "react";
import { Grid, TextField } from "src/components";
import Autocomplete from "src/components/Autocomplete";
import { CustomGroupPredicate } from "src/models/api.request";
import VwPersonelDTO from "src/models/GenelTanimlar/VwPersonelDTO";
import VwPersonel from "src/models/GenelTanimlar/VwPersonelDTO";
import { useBransGetAllQuery } from "src/services/Settings/Generals/BransTanimApi";
import personelService from "src/services/Settings/Generals/personel.service";
import { useAppSelector } from "src/store";
import ParametreGrupEnum from "src/enums/ParametreGrupEnum";
import { helper } from "src/utils/helper";
import { getParameterValue } from "src/utils/ParametreHelper";
import { AutoCompleteTargetNumber } from "../Types/autocomplete.target";
import { translate } from "src/i18n/tHelper";

interface IPersonelAutoCompleteProps {
    value?: number;
    name?: string;
    label?: string;
    predicate?: CustomGroupPredicate<VwPersonelDTO>;
    onChange?: (e: AutoCompleteTargetNumber, value: VwPersonel) => void;
    onBlur?: (e: AutoCompleteTargetNumber) => void;
    helperText?: string;
    sx?: SxProps<Theme>;
    id?: string;
    pasifDahil?: boolean;
    error?: boolean;
    required?: boolean;
    bransGetir?: Array<number>;
    listeGorunsun?: boolean;
    disabled?: boolean;
    ilkKayitDefaultGetir?: boolean;
    readonly?: boolean;
}

const sleep = (delay = 0) => {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}
const translatePath = "common";
const PersonelAutoComplete = (props: IPersonelAutoCompleteProps): JSX.Element => {
    const [options, setOptions] = useState(new Array<VwPersonel>());
    const [value, setValue] = useState<VwPersonel>(new VwPersonel())
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);
    const { organizasyon } = useAppSelector(state => state.userOrganizasyon);
    const bransApi = useBransGetAllQuery();
    useEffect(() => {
        if (props.value > 0) {
            personelService.getOne(props.value).then(res => {
                if (res.responseCode !== 200) {
                    setErrorMessage(res.errorMessage)
                    return;
                }
                setValue(res.data);
            });
        }
        else {
            setValue(new VwPersonelDTO());
            if (props.onChange)
                props.onChange({ target: { value: null, name: props.name } }, new VwPersonelDTO());
        }
    }, [props.value])

    useEffect(() => {
        let active = true;
        if (inputValue === '') {
            setOptions([]);
            if (!props.listeGorunsun) return undefined;
        }
        (async () => {
            setLoading(true)
            await sleep(1e3);

            if (active) {
                var predicate = new CustomGroupPredicate<VwPersonelDTO>();
                predicate.groupOperator = "and";
                predicate.predicates.push({
                    fieldName: "treekey",
                    operator: "startsWith",
                    value1: organizasyon.treekey,
                },
                    {
                        fieldName: "searchText",
                        operator: "like",
                        value1: helper.UpperCaseAsc(inputValue)
                    },
                )
                if (!props.pasifDahil)
                    predicate.predicates.push({
                        fieldName: "durumId",
                        operator: "=",
                        value1: 1,
                    });
                if (props?.bransGetir?.length > 0)
                    predicate.predicates.push({
                        fieldName: "bransId",
                        operator: "in",
                        value1: props.bransGetir
                    });
                if (props.predicate)
                    predicate.predicates.push(props.predicate);

                const res = await personelService.find({
                    filters: predicate,
                    sorts: [
                        { fieldName: "adi" },
                        { fieldName: "soyadi" }
                    ]
                })
                if (res.responseCode !== 200) {
                    setErrorMessage(res.errorMessage)
                    return;
                }
                setOptions(res.data);
                setLoading(false)
            }
        })();

        return () => {
            active = false;
        };
    }, [inputValue]);

    useEffect(() => {
        setErrorMessage(props.helperText)
    }, [props.helperText])

    useEffect(() => {
        if (props.ilkKayitDefaultGetir)
            if (options?.length === 1 && !props.value) {
                //Value ile personeli ekrana alıyor ama onchange kullanılmadığı için render olmuyor haliyle personel ekrana gelsede seçilmemiş gibi davranıldığı için onchange eklendi
                if (props.onChange)
                    props.onChange({ target: { value: options[0]?.id, name: props.name } }, options[0]);
                setValue(options[0]);
            }
    }, [options])

    return (
        <Autocomplete
            fullWidth
            readOnly={props.readonly}
            freeSolo={false}
            multiple={false}
            sx={props.sx}
            id={props.id}
            value={value?.id > 0 ? value : null}
            options={options}
            loading={loading}
            disabled={props.disabled}
            loadingText={translate(translatePath, "Yükleniyor")}
            getOptionLabel={(option) => {
                if (!option.adi)
                    return "";
                let bransAdi = bransApi.data?.find(f => f.id === option.bransId)?.adi
                return option.adi + " " + option.soyadi + (bransAdi ? " - " + bransAdi : "") + " - " + getParameterValue(ParametreGrupEnum.PersonelTurleri, option.grupId);
            }
            }
            onBlur={(e) => {
                if (props.onBlur)
                    props.onBlur({ ...e, target: { value: value?.id, name: props.name } });
            }}
            filterOptions={(x) => x}
            autoComplete
            includeInputInList
            filterSelectedOptions
            isOptionEqualToValue={(option: VwPersonelDTO, value: VwPersonelDTO) => option?.id === value?.id}
            onChange={(event: any, newValue) => {
                setValue(newValue);
                if (props.onChange)
                    props.onChange({ target: { value: newValue?.id, name: props.name } }, newValue);
            }}
            onInputChange={(event, newInputValue, reason) => {
                if (reason === "input")
                    setInputValue(newInputValue);
                else setInputValue("");
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={translate(translatePath, "Arama Yapınız")}
                    label={props.label}
                    error={props.error || Boolean(errorMessage)}
                    helperText={errorMessage}
                    required={props.required}
                />
            )}
            renderOption={(p, v, s) => {
                if (!v?.id)
                    return "";
                let bransAdi = bransApi.data?.find(f => f.id === v.bransId)?.adi
                return (
                    <li {...p} key={v.id}>
                        <Grid container>
                            <Grid item md={12}>
                                {v.adi + " " + v.soyadi + (v.kimlikNo ? " - " + v.kimlikNo : "")}
                            </Grid>
                            <Grid item md={12}>
                                {getParameterValue(ParametreGrupEnum.PersonelTurleri, v.grupId) + (bransAdi ? " - " + bransAdi : "")}
                            </Grid>
                        </Grid>
                    </li>
                )
            }
            }
        />
    )

}
export default PersonelAutoComplete;